import { ListIcon, KanbanIcon, ChartIcon } from './icons';

export const DEFAULT_VIEW_MODES = [
  { value: 'list', label: 'Liste', icon: ListIcon },
  { value: 'kanban', label: 'Kanban', icon: KanbanIcon },
  { value: 'chart', label: 'Grafik', icon: ChartIcon },
];

/**
 * Liste/Kanban/Grafik segment anahtarı.
 * Props: value, onChange, modes? (varsayılan 3 mod; basit ekranlar alt küme verebilir).
 */
export function ViewSwitch({ value, onChange, modes = DEFAULT_VIEW_MODES }) {
  return (
    <span className="c360-view-switch" role="tablist" aria-label="Görünüm">
      {modes.map((mode) => {
        const Icon = mode.icon;
        const isActive = value === mode.value;
        return (
          <button
            key={mode.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`c360-view-switch-btn${isActive ? ' is-active' : ''}`}
            title={`${mode.label} görünümü`}
            aria-label={`${mode.label} görünümüne geç`}
            disabled={mode.disabled}
            onClick={() => !mode.disabled && onChange(mode.value)}
          >
            <Icon />
          </button>
        );
      })}
    </span>
  );
}
